export { default as Tree } from 'locations/containers/LocationsTreeContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/locations/containers/index.js